import clsx from "clsx"

export function faIcon(name: string, options: FaIconOptions = {}) {
  const type = options.type || "solid"
  const faClass = clsx(
    `fa${type[0]}`,
    "fa-fw",
    `fa-${name}`,
    "mr-0",
    options.spin && "fa-spin",
    options.pulse && "fa-pulse",
    options.class,
  )
  return (
    <i className={faClass} style={options.style}>
      {options.text}
    </i>
  )
}

export interface FaIconOptions {
  type?: "solid" | "regular"
  class?: string
  style?: React.CSSProperties
  text?: React.ReactNode
  spin?: boolean
  pulse?: boolean
}
